import gql from 'graphql-tag';

// TODO: defaultAdminType variable should be removed when App support is no longer required for querying adminFee

const GET_QUOTATION_QUERY = gql`
  query Quotation($input: PricingInput!) {
    pricing: getQuotation(input: $input) {
      adminFee
      tenantDiscountPercentage
      downPayment
      downPaymentWithoutOffer
      downPaymentMaxCapType
      downPaymentMaxCapValue
      contractDurationType
      checkIn
      checkOut
      endContractDate
      landlordContractType
      listingPrice
      dailyPrice
      monthlyPrice
      monthlyPriceWithoutOffer
      tenantPayments
      tenantPaymentsWithoutOffer
      reservationPrice
      securityDeposit
      securityDepositType
      startContractDate
      tenantFeeGross
      tenantFeeGrossOriginal
      tenantPayments
      vat
      totalContractValue
      currencyCode
      offer {
        id
        discountType
        discountValue
      }
      downPaymentStrategy
      tenantPaymentsWithCoverage {
        downPaymentFrom
        downPaymentTo
        downPaymentDays
        payments {
          amount
          days
          from
          to
        }
      }
    }
  }
`;

export const getQuotationQuery =
  client =>
  ({
    listingId,
    checkInDate,
    checkOutDate,
    contractDurationType,
    tenantCommissionStrategy,
    downPaymentStrategy
  }) =>
    client.query({
      query: GET_QUOTATION_QUERY,
      fetchPolicy: 'network-only',
      variables: {
        input: {
          listingId,
          checkInDate,
          checkOutDate,
          contractDurationType,
          tenantCommissionStrategy,
          downPaymentStrategy
        }
      }
    });

const GET_ADMIN_FEE_QUERY = gql`
  query AdminFee($listingId: ID!, $defaultAdminType: Boolean) {
    adminFee(listingId: $listingId, defaultAdminType: $defaultAdminType) {
      feeType
      feeValue
      depositType
      depositValue
    }
  }
`;

export const getAdminFeeQuery =
  client =>
  ({ listingId, defaultAdminType }) =>
    client.query({
      query: GET_ADMIN_FEE_QUERY,
      fetchPolicy: 'network-only',
      variables: {
        listingId,
        defaultAdminType
      }
    });

export default {
  getQuotationQuery,
  getAdminFeeQuery
};
